module.exports = __webpack_public_path__ + "img/kerkstraat.c365e003.jpg";